import { type MouseEvent } from "react";
import { useTranslation } from "react-i18next";

import { type INotificationResource } from "@sol/sdk";
import { Check01 } from "@sol/uikit/core/icons/General/Check01";
import { Box } from "@sol/uikit/core/icons/TravelAndLocation/Box";
import { Tooltip } from "@sol/uikit/data-display/Tooltip/Tooltip";
import { Button } from "@sol/uikit/general/Button/Button";

import { isNotificationUnread } from "@/entities/notification";

type Props = {
    notification: INotificationResource;
    onMarkAsRead: () => void;
    onArchive: () => void;
};

// Each action moves the rows, so the second click of a double click would land on another action or row
const ignoringRepeatedClicks = (action: () => void) => (event: MouseEvent) => {
    if (event.detail <= 1) {
        action();
    }
};

export const NotificationActions = ({ notification, onMarkAsRead, onArchive }: Props) => {
    const [t] = useTranslation();

    return (
        <>
            {isNotificationUnread(notification) && (
                <Tooltip title={t("navbar.markAsRead")}>
                    <Button
                        type="text"
                        size="small"
                        aria-label={t("navbar.markAsRead")}
                        icon={<Check01 size={16} />}
                        onClick={ignoringRepeatedClicks(onMarkAsRead)}
                    />
                </Tooltip>
            )}
            <Tooltip title={t("navbar.archive")}>
                <Button
                    type="text"
                    size="small"
                    aria-label={t("navbar.archive")}
                    icon={<Box size={16} />}
                    onClick={ignoringRepeatedClicks(onArchive)}
                />
            </Tooltip>
        </>
    );
};
